import { render, staticRenderFns } from "./EExpansionEtapasList.vue?vue&type=template&id=864534fa"
import script from "./EExpansionEtapasList.vue?vue&type=script&lang=js"
export * from "./EExpansionEtapasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports